import React, { useEffect, Fragment, useState, useCallback } from "react";
import { NavLink } from "react-router-dom";

import FooterComponent from "../../components/FooterComponent";

import "./index.css";

import { Card } from "./Card";

import l1Image from "../../assets/landing-page/l-1.webp";
import l2Image from "../../assets/landing-page/l-2.webp";
import l3Image from "../../assets/landing-page/l-3.webp";

const allShuttles = [
  {
    id: 1,
    title: "UACS Shuttles",
    subTitle: (
      <span>
        16<sup>th</sup> September onwards
      </span>
    ),
    time: "Shuttles connecting Sahastradhara with Gauchar and Joshiyara.",
    badgeText: "Shuttles",
    priceType: "Per seat",
    price: "₹3870/- onwards",
    previousPrice: "₹3870/- onwards",
    bookNowLink: (
      <NavLink to="/bookwithus?tab=UACS">
        <button className="desktop-button">Book Now</button>
      </NavLink>
    ),
  },
  {
    id: 2,
    title: "Badrinath Shuttles",
    subTitle: (
      <span>
        23<sup>rd</sup> April onwards
      </span>
    ),
    time: "Shuttle service between Gauchar and Badrinath. Same day return and night halt options available.",
    badgeText: "Shuttles",
    priceType: "Per seat",
    price: "₹22000/- onwards",
    previousPrice: "₹22000/- onwards",
    bookNowLink: (
      <NavLink to="/bookwithus?tab=BADRINATH">
        <button className="desktop-button">Book Now</button>
      </NavLink>
    ),
  },
];

const allJoyRides = [
  {
    id: 1,
    title: "Tumakur By Sky - Dasara 2026",
    subTitle: (
      <span>
        11<sup>th</sup>–21<sup>st</sup> October 2026
      </span>
    ),
    time: "Tumkur University Helipad · Daily, including Sundays.",
    badgeText: "Joy Rides",
    priceType: "Per passenger · inclusive of GST",
    price: "₹4,100",
    showPrice: true,
    bookNowLink: (
      <NavLink to="/book/tumakur-by-sky-2026">
        <button className="desktop-button">Book Now</button>
      </NavLink>
    ),
  },
];

const helicopterImages = [l1Image, l2Image, l3Image];

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentImageIndex + 1) % helicopterImages.length;
      setNextImageIndex(nextIndex);

      setIsTransitioning(true);

      setTimeout(() => {
        setCurrentImageIndex(nextIndex);
        setNextImageIndex((nextIndex + 1) % helicopterImages.length);
        setIsTransitioning(false);
      }, 1000);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentImageIndex]);

  return (
    <Fragment>
      <div className="homeWrapper">
        <div
          className={`helicopterBackgroundContainer ${
            isTransitioning ? "transitioning" : ""
          }`}
        >
          <div
            className="helicopterBackground helicopterBackgroundNext"
            style={{
              backgroundImage: `url(${helicopterImages[nextImageIndex]})`,
            }}
          >
            <div className="helicopterOverlay"></div>
          </div>
          <div
            className={`helicopterBackground helicopterBackgroundCurrent ${
              isTransitioning ? "blur-out" : ""
            }`}
            style={{
              backgroundImage: `url(${helicopterImages[currentImageIndex]})`,
            }}
          >
            <div className="helicopterOverlay"></div>
          </div>
        </div>

        <div className="contentContainer">
          {allShuttles.length > 0 && (
            <div className="section">
              <div className="titleTwo">Shuttles</div>
              <div className="cardsWrapper">
                {allShuttles.map((p) => (
                  <Card
                    key={p.id}
                    id={p.id}
                    badgeText={p.badgeText}
                    subTitle={p.subTitle}
                    mainTitle={p.title}
                    time={p.time}
                    price={p.price}
                    priceType={p.priceType}
                    previousPrice={p.previousPrice}
                    description={p.description}
                    bookNowLink={p.bookNowLink}
                    earlyBirdEndDate={p.earlyBirdEndDate}
                    earlyBirdDiscount={p.earlyBirdDiscount}
                  />
                ))}
              </div>
            </div>
          )}
          {allJoyRides.length > 0 && (
            <div className="section">
              <div className="titleTwo">Joy Rides</div>
              <div className="cardsWrapper">
                {allJoyRides.map((p) => (
                  <Card
                    key={p.id}
                    id={p.id}
                    badgeText={p.badgeText}
                    subTitle={p.subTitle}
                    mainTitle={p.title}
                    time={p.time}
                    price={p.price}
                    priceType={p.priceType}
                    previousPrice={p.previousPrice}
                    description={p.description}
                    bookNowLink={p.bookNowLink}
                    showPrice={p.showPrice}
                    priceInfo={p.priceInfo}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <FooterComponent />
    </Fragment>
  );
};

export default Home;
